import { currencyOptions } from 'v3/utils/formatter';

export const LoadValueTypeOptions = [
  { label: 'Por viagem', value: 'Por viagem' },
  { label: 'Por tonelada', value: 'Por tonelada' },
];

export const NegotiationTypeOptions = [
  { label: 'Frete spot', value: 'Frete spot' },
  { label: 'Frete tabela', value: 'Frete tabela' },
];

export const disableFieldConditions = {
  toll_value: ['route_without_toll'],
  discharge_value: [
    'payment_reimbursement',
    'client_not_charge',
    'included_in_freight',
    'client_assumes_cost',
  ],
  grissAd: ['not_selected_griss'],
  ferry: ['not_selected_ferry'],
  charge_value: ['not_selected_fee'],
  icms: ['icms_exempt'],
};

export const inputsLoadConditionsToShow = [
  'not_selected',
  'customer_retains',
  'not_selected_discharge',
  'client_pays_insurance',
  'receives_client_and_transfers',
  'only_with_receipt',
  'receives_client_and_retains',
  'transfers_to_carrier',
  'not_selected_icms',
  'retains_in_transporter',
];

export const shipmentTransferToShow = [
  'not_selected',
  'not_selected_discharge',
  'receives_client_and_transfers',
  'client_provides_card',
  'transfers_to_carrier',
];

export function normalizaFreightValues(
  {
    data,
    customerFields,
    insuranceCoopercargaValue,
    customerExtraFields,
    inputsExtraFields,
    shipmentDiscounts,
    shipmentDiscountsExtraFields,
    shipmentTransferExtraFields,
    pcpObservation,
    negotiatorObservation,
    totalCustomerValue,
    totalInputValuesComputed,
    fareCompany,
    balance,
    advanceMoneyExternal,
    advanceMoney,
    travelMargin,
    totalShipmentDiscounts,
    totalShipmentTransfer,
    erpExchangeValue,
    margins,
  },
  currency = 'BRL',
) {
  const prop = currency === 'BRL' ? 'value' : 'dollarValue';
  const totalProp = currency === 'BRL' ? 'total' : 'totalDollarValue';

  return {
    loadValueType: data?.loadValueType,
    negotiationType: data?.negotiationType,
    currency: data?.currency,
    cargoValue: Number(data?.cargoValue),
    exchangeDay: Number(data?.exchangeDay),
    freightExchange: Number(data?.freightExchange),
    erpExchangeValue,
    customer: {
      takerValue: {
        value: Number(customerFields.takerValue[prop]),
        action: customerFields.takerValue.action,
      },
      tollValue: {
        value: Number(customerFields.tollValue[prop]),
        action: customerFields.tollValue.action,
      },
      dischargeValue: {
        value: Number(customerFields.dischargeValue[prop]),
        action: customerFields.dischargeValue.action,
      },
      gris: {
        value: Number(customerFields.gris[prop]),
        action: customerFields.gris.action,
        percentage: Number(customerFields.gris?.percentage),
      },
      adValorem: {
        value: Number(customerFields.adValorem[prop]),
        percentage: Number(customerFields.adValorem?.percentage),
      },
      chargeValue: {
        value: Number(customerFields.chargeValue[prop]),
        action: customerFields.chargeValue.action,
      },
      ferry: {
        value: Number(customerFields.ferry[prop]),
        action: customerFields.ferry.action,
      },
      ICMS: {
        value: Number(customerFields.ICMS[prop]),
        action: customerFields.ICMS.action,
        percentage: Number(customerFields.ICMS?.percentage),
      },
      total: Number(totalCustomerValue[totalProp]),
      extras: customerExtraFields.map((field) => ({
        label: field.label,
        value: Number(field[prop]),
        showToDriver: field.showToDriver,
      })),
    },
    discounts: {
      coopercargaInsurance: {
        value: Number(insuranceCoopercargaValue[prop]),
        percentage: Number(insuranceCoopercargaValue?.percentage),
      },
      total: totalInputValuesComputed[totalProp],
      extras: inputsExtraFields.map((field) => ({
        label: field.label,
        value: Number(field[prop]),
        showToDriver: field.showToDriver,
      })),
    },
    fareCompany: fareCompany[totalProp],
    shipmentDiscounts: {
      issueRate: shipmentDiscounts.issueRate[prop],
      total: totalShipmentDiscounts[totalProp],
      extras: shipmentDiscountsExtraFields.map((field) => ({
        label: field.label,
        value: Number(field[prop]),
        showToDriver: field.showToDriver,
      })),
    },
    shipmentTransfers: {
      total: Number(totalShipmentTransfer[totalProp]),
      extras: shipmentTransferExtraFields.map((field) => ({
        label: field.label,
        value: Number(field[prop]),
        showToDriver: field.showToDriver,
      })),
      pcpObservation,
      negotiatorObservation,
    },
    balance: {
      value: Number(balance[prop]),
    },
    advanceMoneyExternal: {
      value: Number(advanceMoneyExternal[prop]),
      percentage: Number(advanceMoneyExternal?.percentage),
    },
    advanceMoney: {
      value: Number(advanceMoney[prop]),
      percentage: Number(advanceMoney?.percentage),
    },
    travelMargin,
    bennerMargin: margins.benner_margin,
  };
}

export function toReplacementPayload(replacement) {
  const extraFields = [
    ...replacement.customer.extras.map((extra) => ({
      manual: 1,
      label: extra.label,
      value: extra.value,
      showToDriver: extra.showToDriver,
      type: 'CUSTOMER',
    })),
    ...replacement.discounts.extras.map((extra) => ({
      manual: 1,
      label: extra.label,
      value: extra.value,
      showToDriver: extra.showToDriver,
      type: 'DISCOUNT',
    })),
    ...replacement.shipmentDiscounts.extras.map((extra) => ({
      manual: 1,
      label: extra.label,
      value: extra.value,
      showToDriver: extra.showToDriver,
      type: 'SHIPMENT_DISCOUNT',
    })),
    ...replacement.shipmentTransfers.extras.map((extra) => ({
      manual: 1,
      label: extra.label,
      value: extra.value,
      showToDriver: extra.showToDriver,
      type: 'SHIPMENT_TRANSFER',
    })),
  ];

  return {
    takerValue: replacement?.customer?.takerValue?.value,
    tollValue: replacement?.customer?.tollValue?.value,
    dischargeValue: replacement?.customer?.dischargeValue?.value,
    gris: replacement?.customer?.gris?.value,
    grisPercentage: replacement?.customer?.gris?.percentage,
    adValorem: replacement?.customer?.adValorem?.value,
    adValoremPercentage: replacement?.customer?.adValorem?.percentage,
    chargeValue: replacement?.customer?.chargeValue?.value,
    ferry: replacement?.customer?.ferry?.value,
    icms: replacement?.customer?.ICMS?.value,
    icmsPercentage: replacement?.customer?.ICMS?.percentage,
    issueRate: replacement?.shipmentDiscounts?.issueRate,
    coopercargaInsurance: replacement?.discounts?.coopercargaInsurance?.value,
    fareCompany: replacement?.fareCompany,
    exchange: replacement?.erpExchangeValue,
    pcpObservation: replacement?.shipmentTransfers?.pcpObservation,
    currency: replacement?.currency?.value || 'BRL',
    loadValueType: replacement?.loadValueType?.value,
    negotiationType: replacement?.negotiationType?.value,
    negotiatorObservation: replacement?.shipmentTransfers?.negotiatorObservation,
    advanceMoneyPercentage: replacement?.advanceMoney?.percentage,
    advanceMoneyPercentageExternal: replacement?.advanceMoneyExternal?.percentage,
    balance: replacement?.balance?.value,
    margin: replacement?.travelMargin,
    bennerMargin: replacement?.bennerMargin,
    actionTollId: replacement?.customer?.tollValue?.action?.id,
    actionDischargeId: replacement?.customer?.dischargeValue?.action?.id,
    actionChargeId: replacement?.customer?.chargeValue?.action?.id,
    actionGrissAdvaloremId: replacement?.customer?.gris?.action?.id,
    actionIcmsId: replacement?.customer?.ICMS?.action?.id,
    actionFerryId: replacement?.customer?.ferry?.action?.id,
    extraFields,
  };
}

export function loadToFreightData(loadData, travelData) {
  const freightExchange = loadData?.freightExchange?.toFixed(4) || loadData?.exchange;
  const exchangeDay = loadData?.exchangeDay?.toFixed(4) || loadData?.exchange;
  const currency = currencyOptions.find((item) => item.value === loadData?.currency);

  const loadValueType = LoadValueTypeOptions.find((item) => item.value === loadData?.loadValueType);
  const negotiationType = NegotiationTypeOptions.find(
    (item) => item.value === loadData?.negotiationType,
  );

  const cooperIns = loadData?.cargInputs?.find(
    (item) => item.label.toLowerCase() === 'seguro coopercarga',
  );

  const cargInputsWithoutCooperInsurance = loadData?.cargInputs?.filter(
    (item) => item !== cooperIns,
  );

  const issue = loadData?.shipmentDiscounts?.find(
    (item) => item.label.toLowerCase() === 'taxa de emissão',
  );

  const cargShipmentDiscountsWithoutTaxEmmited = loadData?.shipmentDiscounts?.filter(
    (item) => item !== issue,
  );

  const exchangeContract = loadData?.exchangeContract;

  return {
    loadValueType,
    negotiationType,
    currency,
    freightExchange,
    exchangeDay,
    exchangeContract,
    cargoValue: loadData?.cargoValue,
    attended: !!travelData,
    customData: {
      customer: {
        takerValue: {
          value: Number(loadData?.takerValue?.toFixed(2)),
        },
        tollValue: {
          value: Number(loadData?.tollValue?.toFixed(2)),
          action: loadData?.tollObservation,
        },
        dischargeValue: {
          value: Number(loadData?.dischargeValue?.toFixed(2)),
          action: loadData?.dischargeObservation,
        },
        gris: {
          value: Number(loadData?.gris?.toFixed(2)),
          percentage: loadData?.grisPercentage,
          action: loadData?.grissAdObservation,
        },
        adValorem: {
          value: Number(loadData?.adValorem?.toFixed(2)),
          percentage: loadData?.adValoremPercentage,
        },
        chargeValue: {
          value: Number(loadData?.chargeValue?.toFixed(2)),
          action: loadData?.chargeObservation,
        },
        ferry: {
          value: Number(loadData?.ferry?.toFixed(2)),
          action: loadData?.ferryObservation,
        },
        ICMS: {
          value: Number(loadData?.icms?.toFixed(2)),
          percentage: loadData?.icmsPercentage,
          action: loadData?.icmsObservation,
        },
        extras: loadData?.extraFields?.map(field => ({
          id: field.id,
          label: field.label,
          value: Number(field.value?.toFixed(2)),
          showToDriver: field.showToDriver,
        })),
      },
      discounts: {
        coopercargaInsurance: {
          value: Number(cooperIns?.value?.toFixed(2)),
        },
        extras: cargInputsWithoutCooperInsurance?.map((field) => ({
          id: field.id,
          label: field.label,
          value: Number(field.value?.toFixed(2)),
          showToDriver: field.show_to_driver,
        })),
      },
      shipmentDiscounts: {
        issueRate: {
          value: Number(issue?.value?.toFixed(2)),
        },
        extras: cargShipmentDiscountsWithoutTaxEmmited?.map((field) => ({
          id: field.id,
          label: field.label,
          value: Number(field.value?.toFixed(2)),
          showToDriver: field.show_to_driver,
        })),
      },
      shipmentTransfers: {
        pcpObservation: loadData?.pcpObservation,
        negotiatorObservation: travelData?.negotiatorObservation,
        extras: loadData?.shipmentTransfers?.map(field => ({
          id: field.id,
          label: field.label,
          value: Number(field.value?.toFixed(2)),
          showToDriver: field.show_to_driver,
        })),
      },
      advanceMoney: {
        percentage: loadData?.advanceMoneyPercentage,
      },
      advanceMoneyExternal: {
        percentage: loadData?.advanceMoneyPercentageExternal,
      },
      balance: {
        value: Number(travelData?.balance?.toFixed(2)),
      },
      travelMargin: travelData?.margin,
      shipper: travelData?.shipper,
    },
  };
}
export function loadReplacementToFreightData(loadData, travelData) {
  const [replacement] = loadData?.replacements || [];
  const freightExchange = loadData?.freightExchange?.toFixed(4) || replacement?.exchange;
  const exchangeDay = loadData?.exchangeDay?.toFixed(4) || replacement?.exchange;
  const currency = currencyOptions.find((item) => item.value === replacement?.currency);

  const loadValueType = LoadValueTypeOptions.find(
    (item) => item.value === replacement?.loadValueType,
  );
  const negotiationType = NegotiationTypeOptions.find(
    (item) => item.value === replacement?.negotiationType,
  );

  const customerExtraFields = replacement?.extraFields.filter(({ type }) => type === 'CUSTOMER');

  const discountsExtraFields = replacement?.extraFields.filter(({ type }) => type === 'DISCOUNT');

  const shipmentDiscountsExtraFields = replacement?.extraFields.filter(
    ({ type }) => type === 'SHIPMENT_DISCOUNT',
  );

  const shipmentTransfersExtraFields = replacement?.extraFields.filter(
    ({ type }) => type === 'SHIPMENT_TRANSFER',
  );

  const exchangeContract = loadData?.exchangeContract;

  return {
    loadValueType,
    negotiationType,
    currency,
    freightExchange,
    exchangeDay,
    exchangeContract,
    cargoValue: loadData?.cargoValue,
    attended: !!travelData,
    customData: {
      customer: {
        takerValue: {
          value: Number(replacement?.takerValue?.toFixed(2)),
        },
        tollValue: {
          value: Number(replacement?.tollValue?.toFixed(2)),
          action: replacement?.tollObservation,
        },
        dischargeValue: {
          value: Number(replacement?.dischargeValue?.toFixed(2)),
          action: replacement?.dischargeObservation,
        },
        gris: {
          value: Number(replacement?.gris?.toFixed(2)),
          percentage: replacement?.grisPercentage,
          action: replacement?.grissAdObservation,
        },
        adValorem: {
          value: Number(replacement?.adValorem?.toFixed(2)),
          percentage: replacement?.adValoremPercentage,
        },
        chargeValue: {
          value: Number(replacement?.chargeValue?.toFixed(2)),
          action: replacement?.chargeObservation,
        },
        ferry: {
          value: Number(replacement?.ferry?.toFixed(2)),
          action: replacement?.ferryObservation,
        },
        ICMS: {
          value: Number(replacement?.icms?.toFixed(2)),
          percentage: replacement?.icmsPercentage,
          action: replacement?.icmsObservation,
        },
        extras: customerExtraFields,
      },
      discounts: {
        coopercargaInsurance: {
          value: Number(replacement?.coopercargaInsurance),
        },
        extras: discountsExtraFields,
      },
      shipmentDiscounts: {
        issueRate: {
          value: Number(replacement?.issueRate?.toFixed(2)),
        },
        extras: shipmentDiscountsExtraFields,
      },
      shipmentTransfers: {
        pcpObservation: replacement?.pcpObservation,
        negotiatorObservation: replacement?.negotiatorObservation,
        extras: shipmentTransfersExtraFields,
      },
      advanceMoney: {
        percentage: replacement?.advanceMoneyPercentage,
      },
      advanceMoneyExternal: {
        percentage: replacement?.advanceMoneyPercentageExternal,
      },
      balance: {
        value: Number(replacement?.balance?.toFixed(2)),
      },
      travelMargin: replacement?.margin,
      shipper: travelData?.shipper,
    },
  };
}
